import {
  __decorateClass
} from "./chunk-QUKACBNK.js";

// src/components/layout.ts
import {
  html as html4,
  LitElement as LitElement3
} from "@spectrum-web-components/base";
import {
  property as property3,
  queryAsync,
  state
} from "@spectrum-web-components/base/src/decorators.js";
import "@spectrum-web-components/theme/sp-theme.js";
import "@spectrum-web-components/button/sp-button.js";
import "@spectrum-web-components/action-button/sp-action-button.js";
import "@spectrum-web-components/link/sp-link.js";
import "@spectrum-web-components/divider/sp-divider.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-show-menu.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-settings.js";
import {
  trigger
} from "@spectrum-web-components/overlay/src/overlay-trigger-directive.js";

// src/components/adobe-logo.ts
import {
  html,
  LitElement
} from "@spectrum-web-components/base";
import {
  customElement,
  property
} from "@spectrum-web-components/base/src/decorators.js";

// src/components/adobe-logo.css
import { css } from "lit";
var styles = css`:host{display:inline-flex}`;
var adobe_logo_default = styles;

// src/components/adobe-logo.ts
var SpectrumLogo = class extends LitElement {
  constructor() {
    super(...arguments);
    this.size = "36px";
  }
  static get styles() {
    return [adobe_logo_default];
  }
  render() {
    return html`
            <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                viewBox="0 0 30 26"
                width="${this.size}"
                xml:space="preserve"
                role="img"
                aria-label="Adobe"
            >
                <path
                    fill="#FA0F00"
                    d="M19 0h11v26zM11.1 0H0v26zM15 9.6L22.1 26h-4.6l-2.1-5.2h-5.2z"
                />
            </svg>
        `;
  }
};
__decorateClass([
  property({ type: String })
], SpectrumLogo.prototype, "size", 2);
SpectrumLogo = __decorateClass([
  customElement("docs-spectrum-logo")
], SpectrumLogo);

// src/components/code-example.ts
import {
  html as html3,
  LitElement as LitElement2
} from "@spectrum-web-components/base";
import {
  customElement as customElement2,
  property as property2,
  query
} from "@spectrum-web-components/base/src/decorators.js";

// src/utils/templates.ts
import {
  css as css2,
  html as html2
} from "@spectrum-web-components/base";
function toHtmlTemplateString(code) {
  const stringArray = [`${code}`];
  stringArray.raw = [`${code}`];
  return html2(stringArray);
}

// src/components/code-example.css
import { css as css3 } from "lit";
var styles2 = css3`.markup{max-width:100%;border-top:1px solid var(--spectrum-gray-100);background:var(--spectrum-gray-75);border-radius:6px;padding:.75rem 1.5rem;line-height:1.3em;position:relative;overflow:auto hidden}div+.markup{border-radius:0 0 6px 6px}:host{border-radius:var(--code-example-border-radius);border:1px solid var(--spectrum-gray-100);width:100%;--code-example-border-radius:calc(var(--swc-scale-factor)*4px);flex-direction:column;margin:1rem 0 2rem;display:flex;position:relative}.demo-example{z-index:1;max-width:100%;padding:calc(var(--swc-scale-factor)*32px)calc(var(--swc-scale-factor)*40px);border-radius:var(--code-example-border-radius)var(--code-example-border-radius)0 0;background:var(--spectrum-gray-100);flex:1;position:relative;overflow:auto}.demo-example .flex{display:flex}@media (max-width:768px){.demo-example{padding:calc(var(--swc-scale-factor)*16px)calc(var(--swc-scale-factor)*16px)}}.markup{border-top:1px solid var(--spectrum-gray-100);background:var(--spectrum-gray-75);border-radius:0 0 6px 6px;grid-template-rows:minmax(60px,100%);grid-template-columns:100%;padding:.75rem 1.5rem;line-height:1.3em;display:grid;position:relative;overflow:auto}pre{padding-bottom:calc(.75rem + var(--swc-scale-factor)*32px);grid-area:1/1/1/1}.copy-holder{width:100%;height:100%;pointer-events:none;grid-area:1/1/1/1;grid-template-rows:100%;grid-template-columns:100%;display:grid;position:sticky;top:0;left:0}pre{font-family:var(--mod-code-font-family,var(--spectrum-code-font-family));font-style:var(--mod-code-font-style,var(--spectrum-code-font-style));font-weight:var(--mod-code-font-weight,var(--spectrum-code-font-weight));font-size:var(--mod-code-font-size,var(--spectrum-code-font-size));line-height:var(--mod-code-line-height,var(--spectrum-code-line-height));color:var(--highcontrast-code-font-color,var(--mod-code-font-color,var(--spectrum-code-font-color)))}.copy{pointer-events:all;place-self:end;margin:0 -1em -.25em 0}`;
var code_example_default = styles2;

// src/components/code-example-light.css
import { css as css4 } from "lit";
var styles3 = css4`code[class*=language-],pre[class*=language-]{color:#000;text-shadow:0 1px #fff;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none;background:0 0;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;font-size:1em;line-height:1.5}pre[class*=language-]::-moz-selection,pre[class*=language-] ::-moz-selection,code[class*=language-]::-moz-selection,code[class*=language-] ::-moz-selection{text-shadow:none;background:#b3d4fc}pre[class*=language-]::selection,pre[class*=language-] ::selection,code[class*=language-]::selection,code[class*=language-] ::selection{text-shadow:none;background:#b3d4fc}@media print{code[class*=language-],pre[class*=language-]{text-shadow:none}}pre[class*=language-]{margin:.5em 0;padding:1em;overflow:auto}:not(pre)>code[class*=language-],pre[class*=language-]{background:#f5f2f0}:not(pre)>code[class*=language-]{white-space:normal;border-radius:.3em;padding:.1em}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#708090}.token.punctuation{color:#999}.token.namespace{opacity:.7}.token.property,.token.tag,.token.boolean,.token.number,.token.constant,.token.symbol,.token.deleted{color:#905}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#690}.token.operator,.token.entity,.token.url,.language-css .token.string,.style .token.string{color:#9a6e3a;background:#ffffff80}.token.atrule,.token.attr-value,.token.keyword{color:#07a}.token.function,.token.class-name{color:#dd4a68}.token.regex,.token.important,.token.variable{color:#e90}.token.important,.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}.token.attr-name,.token.builtin,.token.char,.token.inserted,.token.selector,.token.string{color:#567f01}.token.punctuation{color:#737373}.language-css .token.function{color:inherit}`;
var code_example_light_default = styles3;

// src/components/code-example-dark.css
import { css as css5 } from "lit";
var styles4 = css5`code[class*=language-],pre[class*=language-]{color:#f8f8f2;text-shadow:0 1px #0000004d;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none;background:0 0;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;font-size:1em;line-height:1.5}pre[class*=language-]{border-radius:.3em;margin:.5em 0;padding:1em;overflow:auto}:not(pre)>code[class*=language-],pre[class*=language-]{background:#272822}:not(pre)>code[class*=language-]{white-space:normal;border-radius:.3em;padding:.1em}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#8292a2}.token.punctuation{color:#f8f8f2}.token.namespace{opacity:.7}.token.property,.token.tag,.token.constant,.token.symbol,.token.deleted{color:#f92672}.token.boolean,.token.number{color:#ae81ff}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#a6e22e}.token.operator,.token.entity,.token.url,.language-css .token.string,.style .token.string,.token.variable{color:#f8f8f2}.token.atrule,.token.attr-value,.token.function,.token.class-name{color:#e6db74}.token.keyword{color:#66d9ef}.token.regex,.token.important{color:#fd971f}.token.important,.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}`;
var code_example_dark_default = styles4;

// src/components/code-example.ts
import { FocusVisiblePolyfillMixin } from "@spectrum-web-components/shared";
import "@spectrum-web-components/action-button/sp-action-button.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-copy.js";

// src/components/copy-to-clipboard.ts
function createNode(text) {
  const node = document.createElement("pre");
  node.style.width = "1px";
  node.style.height = "1px";
  node.style.position = "fixed";
  node.style.top = "5px";
  node.textContent = text;
  return node;
}
function copyNode(node) {
  const text = node.textContent;
  if (!text) {
    return Promise.reject(new Error("Node has no text content"));
  }
  const customElements2 = extractNodeCustomElements(text);
  const importStatements = generateImportStatements(customElements2);
  const fullCopiedText = `${importStatements}
${node.textContent}`;
  if ("clipboard" in navigator) {
    return navigator.clipboard.writeText(fullCopiedText || "");
  }
  const selection = getSelection();
  if (selection == null) {
    return Promise.reject(new Error());
  }
  selection.removeAllRanges();
  const range = document.createRange();
  range.selectNodeContents(node);
  selection.addRange(range);
  document.execCommand("copy");
  selection.removeAllRanges();
  return Promise.resolve();
}
function extractNodeCustomElements(text) {
  const customElements2 = /* @__PURE__ */ new Set();
  const regex = /<sp-[a-zA-Z-]+/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    customElements2.add(match[0].substring(1));
  }
  return customElements2;
}
function generateImportStatements(elements) {
  let imports = "";
  elements.forEach((element) => {
    const elementName = element.substring(3);
    if (element.includes("sp-icon")) {
      imports += `import '@spectrum-web-components/icons-workflow/icons/${element}.js';
`;
    } else {
      imports += `import '@spectrum-web-components/${elementName}/${element}.js';
`;
    }
  });
  return imports;
}
function copyText(text) {
  if ("clipboard" in navigator) {
    return navigator.clipboard.writeText(text);
  }
  const body = document.body;
  if (!body) {
    return Promise.reject(new Error());
  }
  const node = createNode(text);
  body.appendChild(node);
  copyNode(node);
  body.removeChild(node);
  return Promise.resolve();
}

// src/components/code-example.ts
var CodeExample = class extends FocusVisiblePolyfillMixin(LitElement2) {
  constructor() {
    super(...arguments);
    this.codeTheme = "light";
    this.preprocessed = false;
    this.noDemo = false;
    this.prismjsLoaded = false;
    this.liveHTMLTransferred = false;
    this.shouldManageTabOrderForScrolling = () => {
      [this.markup, this.demo].map((el) => {
        if (!el) {
          return;
        }
        const { offsetWidth, scrollWidth } = el;
        if (offsetWidth < scrollWidth) {
          el.tabIndex = 0;
        } else {
          el.removeAttribute("tabindex");
        }
      });
    };
  }
  static get styles() {
    return [code_example_default];
  }
  get codeSlot() {
    const code = [...this.children || []].find(
      (child) => child.slot === "code"
    );
    return code || this;
  }
  get highlightedHTML() {
    const el = this.codeSlot;
    return el.innerHTML || "";
  }
  get liveHTML() {
    const el = this.codeSlot;
    return el.textContent || "";
  }
  get language() {
    if (this.classList.contains("language-javascript")) {
      return "javascript";
    }
    return "markup";
  }
  get showDemo() {
    if (this.noDemo) {
      return false;
    }
    return this.classList.contains("language-html") || this.classList.contains("language-html-live");
  }
  get highlightedCode() {
    const highlightedHTML = this.preprocessed ? this.highlightedHTML : window.Prism.highlight(
      this.liveHTML,
      window.Prism.languages[this.language],
      this.language
    );
    const code = toHtmlTemplateString(highlightedHTML);
    return html3`
            <pre><code>${code}</code></pre>
        `;
  }
  get renderedCode() {
    if (this.classList.contains("language-html-live") && !this.liveHTMLTransferred) {
      const demo = this.querySelector('[slot="demo"]') || document.createElement("div");
      demo.slot = "demo";
      demo.innerHTML = this.liveHTML;
      this.append(demo);
      this.liveHTMLTransferred = true;
    }
    return toHtmlTemplateString(this.liveHTML);
  }
  shouldUpdate() {
    if (this.preprocessed || this.prismjsLoaded) {
      return true;
    }
    if (!this.preprocessed) {
      import("./prism-XLZF4N6Q.js").then(() => {
        this.prismjsLoaded = true;
        this.requestUpdate();
      });
    }
    return false;
  }
  render() {
    const { highlightedCode, renderedCode } = this;
    return html3`
            ${this.showDemo ? html3`
                      <div class="demo-example">
                          <slot name="demo">${renderedCode}</slot>
                      </div>
                  ` : void 0}
            <bdo class="markup" dir="ltr">
                ${highlightedCode}
                <div class="copy-holder">
                    <sp-action-button
                        class="copy"
                        @click=${this.copyToClipboard}
                        quiet
                    >
                        <sp-icon-copy slot="icon"></sp-icon-copy>
                        Copy to Clipboard
                    </sp-action-button>
                </div>
            </bdo>
            <style>
                ${this.codeTheme === "light" ? code_example_light_default.toString() : code_example_dark_default.toString()}
            </style>
        `;
  }
  copyToClipboard() {
    copyNode(this);
  }
  updated() {
    setTimeout(this.shouldManageTabOrderForScrolling);
  }
  trackTheme() {
    const queryThemeEvent = new CustomEvent("sp-track-theme", {
      bubbles: true,
      composed: true,
      detail: {
        callback: (color) => {
          this.codeTheme = color.startsWith("light") ? "light" : "dark";
        }
      },
      cancelable: true
    });
    this.dispatchEvent(queryThemeEvent);
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(
      "resize",
      this.shouldManageTabOrderForScrolling
    );
    this.trackTheme();
  }
  disconnectedCallback() {
    window.removeEventListener(
      "resize",
      this.shouldManageTabOrderForScrolling
    );
    this.trackTheme();
    super.disconnectedCallback();
  }
};
__decorateClass([
  query("#markup")
], CodeExample.prototype, "markup", 2);
__decorateClass([
  query(".demo-example")
], CodeExample.prototype, "demo", 2);
__decorateClass([
  property2()
], CodeExample.prototype, "codeTheme", 2);
__decorateClass([
  property2({ type: Boolean })
], CodeExample.prototype, "preprocessed", 2);
__decorateClass([
  property2({ type: Boolean, attribute: "no-demo" })
], CodeExample.prototype, "noDemo", 2);
CodeExample = __decorateClass([
  customElement2("code-example")
], CodeExample);

// src/components/layout.css
import { css as css6 } from "lit";
var styles5 = css6`:host{min-height:100vh;min-height:100dvh;display:block}#app{width:100%;height:100%;min-height:100vh;min-height:100dvh;flex-direction:column;display:flex}docs-side-nav:not(:defined){display:none}@media screen and (min-width:961px){docs-side-nav:not(:defined){background-color:var(--spectrum-gray-75);max-width:calc(var(--swc-scale-factor)*192px);max-height:100vh;height:100vh;flex-direction:column;padding:0 24px 24px;display:flex;position:sticky;top:0;left:0}docs-side-nav:not(:defined) ::slotted([slot=logo]){margin:0 -24px}docs-side-nav:not(:defined) ::slotted([slot=side-nav]){width:216px;flex:1;margin-top:56px}}#body{grid-template-columns:auto calc(100% - var(--swc-scale-factor)*240px);color:var(--spectrum-gray-800);background-color:var(--spectrum-gray-50);flex:auto;display:grid}@media screen and (max-width:960px){#body{height:50%;grid-template-columns:100%}}#page{padding:calc(var(--swc-scale-factor)*40px)calc(var(--swc-scale-factor)*56px);max-width:1080px;width:100%;box-sizing:border-box;margin-left:auto;margin-right:auto}.manage-theme{min-height:52px;grid-template-columns:auto auto;justify-content:flex-end;display:grid}.theme-control{flex-direction:column;display:flex}@media screen and (max-width:960px){#page{padding:calc(var(--swc-scale-factor)*8px)calc(var(--swc-scale-factor)*24px)}.manage-theme{margin-left:0;margin-right:0}}@media screen and (min-width:525px){.manage-theme{flex-flow:wrap;display:flex}}header{min-height:calc(var(--swc-scale-factor)*48px);border-bottom:1px solid var(--spectrum-gray-200);background-color:var(--spectrum-gray-50);z-index:2;--spectrum-actionbutton-height:calc(var(--swc-scale-factor)*40px);--spectrum-actionbutton-min-width:calc(var(--swc-scale-factor)*40px);--spectrum-alias-workflow-icon-size:22px;flex-direction:row;justify-content:space-between;align-items:center;padding-inline:8px;display:flex;position:sticky;top:0;left:0;right:0}header svg{stroke:#0000;height:100%}.theme-control{margin-inline-start:calc(var(--swc-scale-factor)*32px)}sp-field-label:not(:defined){height:calc(var(--spectrum-fieldlabel-m-text-line-height,var(--spectrum-alias-component-text-line-height)) + var(--spectrum-fieldlabel-m-padding-top,calc(var(--swc-scale-factor)*4px)) + var(--spectrum-fieldlabel-m-padding-bottom,calc(var(--swc-scale-factor)*5px)));min-width:70px}sp-picker:not(:defined){height:var(--spectrum-picker-m-height,var(--spectrum-alias-item-height-m));min-width:70px}sp-picker:not(:defined) sp-menu-item{display:none}@media screen and (min-width:961px){header{display:none}}.alerts{width:100vw;text-align:center;flex-direction:column;display:flex;position:fixed;bottom:0}.alerts sp-toast{margin:0 auto calc(var(--swc-scale-factor)*24px)}#logo{padding:calc(var(--swc-scale-factor)*28px)calc(var(--swc-scale-factor)*24px);color:var(--spectrum-gray-800);width:calc(var(--swc-scale-factor)*192px);border-radius:4px;outline:none;flex-direction:row;margin-bottom:-11px;text-decoration:none;display:flex}#logo docs-spectrum-logo{width:36px;height:31px;margin-right:calc(var(--swc-scale-factor)*16px);flex-shrink:0;margin-bottom:12px;display:block}#logo .title{letter-spacing:0;font-size:18px;font-style:normal;font-weight:700;line-height:1.3;font-family:var(--spectrum-alias-body-text-font-family,var(--spectrum-font-family));align-items:center;margin:-3px 0 0}#logo span{white-space:nowrap}aside{max-height:100vh;height:100vh;z-index:10;background-color:var(--spectrum-gray-75);width:calc(var(--swc-scale-factor)*192px);transition:transform var(--spectrum-dialog-confirm-background-entry-animation-duration,var(--spectrum-animation-duration-600))cubic-bezier(0,0,.4,1),visibility 0s linear var(--spectrum-dialog-confirm-background-entry-animation-duration,var(--spectrum-animation-duration-600));visibility:visible;flex-direction:column;display:flex;position:fixed;top:0;right:0;overflow:auto}aside .manage-theme{flex-direction:column;order:1;padding:0 24px 24px;display:flex}.scrim{z-index:10;touch-action:none;position:fixed}aside header{background:0 0;border-color:#0000;justify-content:end;padding-inline:8px}aside .theme-control{margin:0 0 calc(var(--swc-scale-factor)*24px)}sp-underlay[open]+aside{visibility:visible;transition-delay:0s,0s}sp-underlay:not([open])+aside{visibility:hidden;transform:translate(100%)}:host([dir=rtl]) aside{left:0;right:auto}:host([dir=rtl]) sp-underlay:not([open])+aside{transform:translate(-100%)}`;
var layout_default = styles5;

// src/components/layout.ts
import {
  DARK_MODE,
  IS_MOBILE
} from "@spectrum-web-components/reactive-controllers/src/MatchMedia.js";
var SWC_THEME_COLOR_KEY = "swc-docs:theme:color";
var SWC_THEME_SCALE_KEY = "swc-docs:theme:scale";
var SWC_THEME_THEME_KEY = "swc-docs:theme:theme";
var SWC_THEME_SYSTEM_KEY = "swc-docs:theme:system";
var SWC_THEME_DIR_KEY = "swc-docs:theme:dir";
var COLOR_FALLBACK = matchMedia(DARK_MODE).matches ? "dark" : "light";
var SCALE_FALLBACK = matchMedia(IS_MOBILE).matches ? "large" : "medium";
var SYSTEM_FALLBACK = "spectrum";
var DIR_FALLBACK = "ltr";
var DEFAULT_COLOR = window.localStorage ? localStorage.getItem(SWC_THEME_COLOR_KEY) || COLOR_FALLBACK : COLOR_FALLBACK;
var DEFAULT_SCALE = window.localStorage ? localStorage.getItem(SWC_THEME_SCALE_KEY) || SCALE_FALLBACK : SCALE_FALLBACK;
var DEFAULT_SYSTEM = window.localStorage ? localStorage.getItem(SWC_THEME_THEME_KEY) || localStorage.getItem(SWC_THEME_SYSTEM_KEY) || SYSTEM_FALLBACK : SYSTEM_FALLBACK;
var DEFAULT_DIR = window.localStorage ? localStorage.getItem(SWC_THEME_DIR_KEY) || DIR_FALLBACK : DIR_FALLBACK;
var isNarrowMediaQuery = matchMedia("screen and (max-width: 960px)");
var lazyStyleFragment = (name, system) => {
  const fragmentName = `${name}-${system}`;
  switch (fragmentName) {
    case "dark-spectrum":
      import("@spectrum-web-components/theme/theme-dark.js");
      break;
    case "light-spectrum":
      import("@spectrum-web-components/theme/theme-light.js");
      break;
    case "medium-spectrum":
      import("@spectrum-web-components/theme/scale-medium.js");
      break;
    case "large-spectrum":
      import("@spectrum-web-components/theme/scale-large.js");
      break;
    case "dark-express":
      import("@spectrum-web-components/theme/express/theme-dark.js");
      break;
    case "light-express":
      import("@spectrum-web-components/theme/express/theme-light.js");
      break;
    case "medium-express":
      import("@spectrum-web-components/theme/express/scale-medium.js");
      break;
    case "large-express":
      import("@spectrum-web-components/theme/express/scale-large.js");
      break;
    case "light-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/theme-light-core-tokens.js");
      break;
    case "dark-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/theme-dark-core-tokens.js");
      break;
    case "medium-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/scale-medium-core-tokens.js");
      break;
    case "large-spectrum-two":
      import("@spectrum-web-components/theme/spectrum-two/scale-large-core-tokens.js");
      break;
  }
};
var loadDefaults = () => {
  if (DEFAULT_COLOR !== COLOR_FALLBACK || DEFAULT_SCALE !== SCALE_FALLBACK || DEFAULT_SYSTEM !== SYSTEM_FALLBACK) {
    lazyStyleFragment(DEFAULT_COLOR, DEFAULT_SYSTEM);
    lazyStyleFragment(DEFAULT_SCALE, DEFAULT_SYSTEM);
  }
};
var LayoutElement = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.alerts = /* @__PURE__ */ new Map();
    this.color = DEFAULT_COLOR;
    this.dir = DEFAULT_DIR;
    this.open = false;
    this.isNarrow = isNarrowMediaQuery.matches;
    this.theme = DEFAULT_SYSTEM;
    this.scale = DEFAULT_SCALE;
    this.system = DEFAULT_SYSTEM;
    this._themeTrackers = /* @__PURE__ */ new Map();
    this.handleMatchMediaChange = (event) => {
      this.isNarrow = event.matches;
    };
  }
  static get styles() {
    return [layout_default];
  }
  async startManagingContentDirection(el) {
    (await this.themeRoot).startManagingContentDirection(el);
  }
  async stopManagingContentDirection(el) {
    (await this.themeRoot).stopManagingContentDirection(el);
  }
  closeSettings(event) {
    event.target.parentElement?.dispatchEvent(
      new Event("close", { bubbles: true })
    );
  }
  updateColor(event) {
    this.color = event.target.value;
    this._themeTrackers.forEach((tracker) => tracker(this.color));
  }
  updateScale(event) {
    this.scale = event.target.value;
  }
  updateSystem(event) {
    this.system = event.target.value;
  }
  updateDirection(event) {
    const dir = event.target.value;
    this.dir = dir === "rtl" ? dir : "ltr";
    document.documentElement.dir = this.dir;
  }
  handleTrackTheme(event) {
    const target = event.composedPath()[0];
    if (this._themeTrackers.has(target)) {
      this._themeTrackers.delete(target);
    } else {
      this._themeTrackers.set(target, event.detail.callback);
      const callback = this._themeTrackers.get(target);
      if (callback) {
        callback(this.color);
      }
    }
  }
  copyText(event) {
    copyText(event.detail.text);
    this.addAlert(event);
  }
  addAlert(event) {
    const target = event.composedPath()[0];
    if (!this.alerts.has(target)) {
      const close = () => {
        this.alerts.delete(target);
        target.focus();
        this.requestUpdate();
      };
      this.alerts.set(target, {
        count: 0,
        message: "",
        /**
         * <sp-toast> does not allow a `timeout` of less that 6000
         * use this as a cheat to reset the timeout to 6000 for
         * every additional alert.
         */
        element: (count, message) => {
          import("@spectrum-web-components/toast/sp-toast.js");
          return html4`
                        <sp-toast
                            .timeout=${count}
                            variant="info"
                            @close=${close}
                            open
                        >
                            ${message} ${count > 1 ? `(${count} alerts)` : ""}
                        </sp-toast>
                    `;
        }
      });
    }
    const alert = this.alerts.get(target);
    this.alerts.set(target, {
      element: alert.element,
      count: alert.count + 1,
      message: event.detail.message
    });
    this.requestUpdate();
  }
  get sideNav() {
    const navContent = html4`
            <slot name="logo" slot="logo">
                <a id="logo" href="index.html">
                    <docs-spectrum-logo></docs-spectrum-logo>
                    <h1 class="title">
                        Spectrum
                        <br />
                        <span>Web Components</span>
                    </h1>
                </a>
            </slot>
            <slot name="side-nav"></slot>
        `;
    import("./side-nav-FCJ5L273.js");
    return html4`
            <docs-side-nav id="side-nav" .isNarrow=${this.isNarrow}>
                ${navContent}
            </docs-side-nav>
        `;
  }
  get settingsContent() {
    import("@spectrum-web-components/underlay/sp-underlay.js");
    return html4`
            <sp-underlay
                class="scrim"
                @close=${this.closeSettings}
            ></sp-underlay>
            <aside aria-label="Settings">
                ${this.manageTheme}
                <header>
                    <sp-action-button
                        quiet
                        label="Close Settings"
                        @click=${this.closeSettings}
                        id="close-settings-id"
                    >
                        <sp-icon-close slot="icon"></sp-icon-close>
                    </sp-action-button>
                </header>
            </aside>
        `;
  }
  get manageTheme() {
    import("./settings-IPP5ILYA.js");
    return html4`
            <div class="manage-theme" role="form" aria-label="Settings">
                <div class="theme-control">
                    <sp-field-label for="theme-system">System</sp-field-label>
                    <sp-picker
                        id="theme-system"
                        quiet
                        value=${this.system}
                        @change=${this.updateSystem}
                    >
                        <sp-menu-item value="spectrum">Spectrum</sp-menu-item>
                        <sp-menu-item value="express">Express</sp-menu-item>
                        <sp-menu-item value="spectrum-two">
                            Spectrum 2
                        </sp-menu-item>
                    </sp-picker>
                </div>
                <div class="theme-control">
                    <sp-field-label for="theme-color">Color</sp-field-label>
                    <sp-picker
                        id="theme-color"
                        quiet
                        value=${this.color}
                        @change=${this.updateColor}
                    >
                        <sp-menu-item value="light">Light</sp-menu-item>
                        <sp-menu-item value="dark">Dark</sp-menu-item>
                    </sp-picker>
                </div>
                <div class="theme-control">
                    <sp-field-label for="theme-scale">Scale</sp-field-label>
                    <sp-picker
                        id="theme-scale"
                        label="Scale"
                        quiet
                        value=${this.scale}
                        @change=${this.updateScale}
                    >
                        <sp-menu-item value="medium">Medium</sp-menu-item>
                        <sp-menu-item value="large">Large</sp-menu-item>
                    </sp-picker>
                </div>
                <div class="theme-control">
                    <sp-field-label for="theme-direction">
                        Direction
                    </sp-field-label>
                    <sp-picker
                        id="theme-direction"
                        label="Direction"
                        quiet
                        value=${this.dir}
                        @change=${this.updateDirection}
                    >
                        <sp-menu-item value="ltr">LTR</sp-menu-item>
                        <sp-menu-item value="rtl">RTL</sp-menu-item>
                    </sp-picker>
                </div>
            </div>
        `;
  }
  get header() {
    const triggerOptions = {
      overlayOptions: {
        type: "modal"
      },
      insertionOptions: {
        el: () => this.shadowRoot?.querySelector("#body"),
        where: "afterbegin"
      }
    };
    return html4`
            <header>
                <sp-action-button
                    quiet
                    label="Open Navigation"
                    id="toggle-nav-id"
                    ${trigger(() => this.sideNav, triggerOptions)}
                >
                    <sp-icon-show-menu slot="icon"></sp-icon-show-menu>
                </sp-action-button>
                <sp-action-button
                    quiet
                    label="Open Settings"
                    id="toggle-settings-id"
                    ${trigger(() => this.settingsContent, triggerOptions)}
                >
                    <sp-icon-settings slot="icon"></sp-icon-settings>
                </sp-action-button>
            </header>
        `;
  }
  render() {
    return html4`
            <sp-theme
                .color=${this.color}
                .scale=${this.scale}
                .system=${this.system}
                dir=${this.dir}
                id="app"
                @sp-track-theme=${this.handleTrackTheme}
            >
                ${this.isNarrow ? this.header : html4``}
                <div id="body">
                    ${this.isNarrow ? html4`` : this.sideNav}
                    <div
                        id="page"
                        @alert=${this.addAlert}
                        @copy-text=${this.copyText}
                    >
                        ${!this.isNarrow ? this.manageTheme : ""}
                        <slot></slot>
                    </div>
                </div>
                ${this.alerts.size ? html4`
                          <div class="alerts" role="region">
                              ${[...this.alerts.values()].map(
      (alert) => alert.element(alert.count, alert.message)
    )}
                          </div>
                      ` : html4``}
            </sp-theme>
        `;
  }
  firstUpdated() {
    loadDefaults();
    isNarrowMediaQuery.addEventListener(
      "change",
      this.handleMatchMediaChange
    );
  }
  updated(changes) {
    let loadStyleFragments = false;
    if (changes.has("color")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_COLOR_KEY, this.color);
      }
      if (changes.get("color")) {
        loadStyleFragments = true;
      }
      const overview = [
        ...this.querySelectorAll("code-example")
      ];
      overview.forEach((example) => {
        example.codeTheme = this.color;
      });
      document.querySelector("html").style.colorScheme = this.color;
    }
    if (changes.has("scale")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_SCALE_KEY, this.scale);
      }
      if (changes.get("scale")) {
        loadStyleFragments = true;
      }
    }
    if (changes.has("system")) {
      if (window.localStorage) {
        localStorage.setItem(SWC_THEME_SYSTEM_KEY, this.system);
      }
      if (changes.get("system")) {
        loadStyleFragments = true;
      }
    }
    if (changes.has("dir") && window.localStorage) {
      localStorage.setItem(SWC_THEME_DIR_KEY, this.dir);
    }
    if (loadStyleFragments) {
      lazyStyleFragment(this.color, this.system);
      lazyStyleFragment(this.scale, this.system);
    }
  }
};
__decorateClass([
  state()
], LayoutElement.prototype, "alerts", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "color", 2);
__decorateClass([
  property3({ reflect: true })
], LayoutElement.prototype, "dir", 2);
__decorateClass([
  property3({ type: Boolean })
], LayoutElement.prototype, "open", 2);
__decorateClass([
  state()
], LayoutElement.prototype, "isNarrow", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "theme", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "scale", 2);
__decorateClass([
  property3({ attribute: false })
], LayoutElement.prototype, "system", 2);
__decorateClass([
  queryAsync("sp-theme")
], LayoutElement.prototype, "themeRoot", 2);
customElements.define("docs-page", LayoutElement);

// src/index.ts
window.spAlert = (el, message) => {
  el.dispatchEvent(
    new CustomEvent("alert", {
      composed: true,
      bubbles: true,
      detail: {
        message
      }
    })
  );
};
